import { cn } from '@/lib/utils';
import { TabCountBadge } from './TabCountBadge';
import type { AssetTabId, AssetTabItem } from './assetTabs';

interface AssetsTabPillsProps {
  tabs: AssetTabItem[];
  activeTab: AssetTabId;
  onSelectTab: (id: AssetTabId) => void;
}

// Sub-lg equivalent of AssetsTabList (2026-08-19 design update): a horizontal
// pill scroller replaces the Photos ▾ dropdown. Identical props signature so
// AssetsControlBar swaps widgets at the lg breakpoint. Availability is decided
// by the caller — this widget renders whatever tabs it's given.
// min-h-11: the design draws 38px pills, but the viewport suite's 44px
// tap-target floor outranks the mock (recorded in the spec correction).
const AssetsTabPills = ({ tabs, activeTab, onSelectTab }: AssetsTabPillsProps) => (
  <div
    data-testid="asset-view-tab-pills"
    className="flex gap-2 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
  >
    {tabs.map((tab) => {
      const isActive = tab.id === activeTab;
      return (
        <button
          key={tab.id}
          onClick={() => onSelectTab(tab.id)}
          aria-pressed={isActive}
          className={cn(
            'inline-flex min-h-11 shrink-0 cursor-pointer items-center gap-1.5 rounded-full border px-4 text-sm font-semibold whitespace-nowrap transition-colors',
            isActive
              ? 'border-primary bg-primary text-primary-foreground'
              : 'border-input bg-background text-foreground hover:bg-accent'
          )}
        >
          {tab.label}
          {tab.count !== undefined && (
            <TabCountBadge count={tab.count} active={isActive} onPrimary={isActive} />
          )}
        </button>
      );
    })}
  </div>
);

export default AssetsTabPills;
